import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Select, Space, theme } from 'antd';
import { useEffect, useState } from 'react';
import { stageMeta } from 'assets/data/estadosPresupuesto';

const { useToken } = theme;

const STAGE_OPTIONS = Object.values(stageMeta).map((e) => ({
  value: e.key,
  label: e.description,
}));

function BudgetToolbar({ filters, onChange }) {
  const { token } = useToken();
  const [searchInput, setSearchInput] = useState(filters.search ?? '');

  useEffect(() => {
    const t = setTimeout(() => {
      if (searchInput !== (filters.search ?? '')) {
        onChange({ ...filters, search: searchInput });
      }
    }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  const hasFilters =
    (filters.stage && filters.stage.length > 0) ||
    !!filters.search ||
    !!filters.idClient ||
    !!filters.commune;

  const clearAll = () => {
    setSearchInput('');
    onChange({ stage: [], search: '', idClient: null, commune: '' });
  };

  return (
    <Space
      wrap
      size="middle"
      style={{
        padding: token.paddingSM,
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
      }}
    >
      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="Buscar cliente o descripción…"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        style={{ width: 280 }}
      />
      <Select
        mode="multiple"
        allowClear
        placeholder="Estado"
        value={filters.stage ?? []}
        onChange={(value) => onChange({ ...filters, stage: value })}
        options={STAGE_OPTIONS}
        style={{ minWidth: 240 }}
        maxTagCount="responsive"
      />
      <Input
        allowClear
        placeholder="Comuna"
        value={filters.commune ?? ''}
        onChange={(e) => onChange({ ...filters, commune: e.target.value })}
        style={{ width: 180 }}
      />
      {hasFilters && (
        <Button icon={<ClearOutlined />} onClick={clearAll}>
          Limpiar
        </Button>
      )}
    </Space>
  );
}

export default BudgetToolbar;
